import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function EmptyShiftBlocksFacilityView() {
  return (
    <Stack alignItems="center" justifyContent="space-evenly" flex={1}>
      <Illustration type="block-shift" />

      <Stack spacing={2} alignItems="center">
        <Text variant="h5" align="center">
          No blocks of shifts at this moment
        </Text>
        <Text
          variant="body2"
          align="center"
          sx={{ color: (theme) => theme.palette.text.secondary }}
        >
          As soon as this workplace posts a block of shifts, it will be listed here.
        </Text>
      </Stack>
    </Stack>
  );
}
